import { doc, getDoc, updateDoc, setDoc } from 'firebase/firestore';
import { serverTimestamp } from 'firebase/firestore';
import { db } from './config';

// Get user profile
export const getUserProfile = async (userId) => {
  try {
    const userRef = doc(db, 'users', userId);
    const userDoc = await getDoc(userRef);
    
    if (userDoc.exists()) {
      return { id: userDoc.id, ...userDoc.data() };
    }
    return null;
  } catch (error) {
    console.error('Error getting user profile:', error);
    throw error;
  }
};

export async function updateUserProfile(userId, profileData) {
  try {
    console.log('updating user profile');
    const userRef = doc(db, 'users', userId);
    await setDoc(userRef, { ...profileData, updatedAt: serverTimestamp() }, { merge: true });
  } catch (error) {
    console.error('Error updating user profile:', error);
    throw error;
  }
}


// Save user address
export const saveUserAddress = async (userId, addressData) => {
  try {
    const userRef = doc(db, 'users', userId);
    const userDoc = await getDoc(userRef);
    
    if (userDoc.exists()) {
      // Update existing user
      await updateDoc(userRef, {
        addresses: [addressData], // Can be array for multiple addresses
        defaultAddress: addressData,
        updatedAt: new Date()
      });
    } else {
      // Create new user document
      await setDoc(userRef, {
        userId,
        addresses: [addressData],
        defaultAddress: addressData,
        createdAt: new Date(),
        updatedAt: new Date()
      });
    }
    
    return true;
  } catch (error) {
    console.error('Error saving user address:', error);
    throw error;
  }
};

export async function getUserLocation(uid) {
  try {
    const userDoc = await getDoc(doc(db, 'users', uid));
    if (userDoc.exists()) {
      const userData = userDoc.data();
      return userData.location || null;
    }
    return null;
  } catch (error) {
    console.error('Error getting user location:', error);
    return null;
  }
}

export async function getUserPostalCode(uid) {
  try {
    const userDoc = await getDoc(doc(db, 'users', uid));
    if (userDoc.exists()) {
      const userData = userDoc.data();
      return userData.postalCode || '';
    }
    return '';
  } catch (error) {
    console.error('Error getting user postal code:', error);
    return '';
  }
}

// Get user's default address
export const getUserDefaultAddress = async (userId) => {
  try {
    const userProfile = await getUserProfile(userId);
    return userProfile?.defaultAddress || null;
  } catch (error) {
    console.error('Error getting default address:', error);
    return null;
  }
};

export const saveUserLocation = async (userId, addressData) => {
    try {
      const userRef = doc(db, 'users', userId);
      
      // Format location according to schema
      const locationData = {
        location: {
          coordinates: {
            lat: addressData.latitude || 0,
            long: addressData.longitude || 0
          },
          address: addressData.street || '',
          city: addressData.city || ''
        },
        postalCode: addressData.postalCode || '',
        updatedAt: serverTimestamp()
      };
      
      const userDoc = await getDoc(userRef);
      
      if (userDoc.exists()) {
        // Update existing user
        await updateDoc(userRef, locationData);
      } 
      
      return true;
    } catch (error) {
      console.error('Error saving user location:', error);
      throw error;
    }
  };